const contract = {
    "productId":"12345",
    "ownerId":"testseller",
    "productType":"Coffee",
    "realtorFee":5,    
    "price":"50",
    "seller":"0.0.49147325"
}

const transaction = {    
    "accountId":"0.0.49147325",
    "privateKey":"302e020100300506032b657004220420aee75d50350ca2efb8fffb3831070ba31e8eb5e96c9801a5017975dacb38203c",
    "contractId":"0.0.49247412"    
}

export const payload = {contract, transaction}
